import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["query", "category", "publication", "item", "checkbox", "bulkAction"]

  filter() {
    const query = this.queryTarget.value.trim().toLocaleLowerCase()
    const category = this.categoryTarget.value
    const publication = this.publicationTarget.value

    this.itemTargets.forEach((item) => {
      const queryMatches = !query || item.dataset.searchText.includes(query)
      const categories = (item.dataset.categoryIds || "").split(",").filter(Boolean)
      const categoryMatches = !category || categories.includes(category)
      const publicationMatches = !publication || item.dataset.publication === publication
      item.hidden = !(queryMatches && categoryMatches && publicationMatches)
    })
  }

  reset() {
    this.queryTarget.value = ""
    this.categoryTarget.value = ""
    this.publicationTarget.value = ""
    this.filter()
  }

  selectAll() {
    this.itemTargets.forEach((item) => {
      if (!item.hidden) item.querySelector("[data-portal-master-filter-target='checkbox']").checked = true
    })
  }

  clearAll() {
    this.checkboxTargets.forEach((checkbox) => { checkbox.checked = false })
  }

  validateBulk(event) {
    if (!this.checkboxTargets.some((checkbox) => checkbox.checked) || !this.bulkActionTarget.value) {
      event.preventDefault()
      this.bulkActionTarget.setCustomValidity(this.element.dataset.selectionRequiredMessage)
      this.bulkActionTarget.reportValidity()
      return
    }

    this.bulkActionTarget.setCustomValidity("")
  }

  clearValidity() {
    this.bulkActionTarget.setCustomValidity("")
  }
}
